<template>
  <dialog-reset
    height="70vh"
    top="8vh"
    width="75%"
    title="选择备件"
    :visible.sync="visible"
    :zoomShow="false"
  >
    <avue-crud
      v-if="visible"
      ref="crud"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @row-dblclick="handleSelect"
      @on-load="onLoad"
    >
    </avue-crud>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList } from '../../parts-management/api'
import DialogReset from '@/basic-common/components/DialogReset.vue'

export default {
  name: 'SelectSparePartDialog',
  components: {
    DialogReset,
  },
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      visible: false,
      selectedRow: null,
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        addBtn: false,
        menu: false,
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        align: 'center',
        highlightCurrentRow: true,
        column: [
          {
            label: '备件编码',
            prop: 'partCode',
            search: true,
            width: 140,
            overHidden: true,
          },
          {
            label: '备件名称',
            prop: 'partName',
            search: true,
            minWidth: 160,
            overHidden: true,
          },
          {
            label: '规格',
            prop: 'specification',
            width: 120,
            overHidden: true,
          },
          {
            label: '生产厂家',
            prop: 'manufacturer',
            search: true,
            minWidth: 140,
            align: 'center',
            overHidden: true,
          },
          {
            label: '库存',
            prop: 'stockCount',
            width: 90,
            align: 'center',
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.defaultParams = {}
      }
    },
  },
  methods: {
    /**
     * 按关联设备筛选备件（POST body 带 deviceId，与备件管理分页一致）。
     */
    open(deviceId) {
      if (deviceId == null || deviceId === '') {
        this.$message.warning('请先选择关联设备')
        return
      }
      this.defaultParams = { deviceId }
      this.visible = true
      this.selectedRow = null
    },
    handleSelect(row) {
      this.$emit('select', row)
      this.visible = false
    },
    handleConfirm() {
      if (!this.selectedRow) {
        this.$message.warning('请选择一个备件')
        return
      }
      this.$emit('select', this.selectedRow)
      this.visible = false
    },
    currentChange(currentRow) {
      this.selectedRow = currentRow
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .avue-crud__menu {
  display: none;
}
</style>
